import React from 'react';
import notFound from '../../../images/notFound.jpg'

const NotFound = () => {
    return (
        <div className='text-center'>
            <img height={'530vh'} width={'100%'} src={notFound} alt="" />
        </div>
    );
};

export default NotFound;